/**
 * LoreTooltip component.
 * Displays a positioned tooltip with lore title when hovering over a hex with lore.
 * Positioned near the mouse cursor on the canvas.
 */

interface LoreTooltipProps {
    /** Title of the lore entry */
    title: string;
    /** X position relative to canvas container */
    x: number;
    /** Y position relative to canvas container */
    y: number;
}

/**
 * A tooltip that appears near the cursor when hovering over a hex with lore.
 * Uses amber/gold styling to match the lore golden glow theme.
 */
export function LoreTooltip({ title, x, y }: LoreTooltipProps) {
    return (
        <div
            className="absolute z-40 pointer-events-none"
            style={{
                left: x + 12,
                top: y - 8,
                transform: 'translateY(-100%)',
            }}
        >
            <div
                className="px-3 py-2 rounded-lg shadow-lg max-w-xs"
                style={{
                    background: 'linear-gradient(135deg, #f5e6d3 0%, #e8d5b7 100%)',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.3), inset 0 0 20px rgba(139,90,43,0.1)',
                    border: '1px solid rgba(180, 140, 80, 0.4)',
                }}
            >
                <div className="flex items-center gap-2">
                    <span className="text-amber-600 text-sm">📜</span>
                    <span className="text-sm font-serif text-amber-900 truncate">
                        {title}
                    </span>
                </div>
            </div>
            {/* Arrow pointing down */}
            <div
                className="absolute left-4 top-full w-0 h-0"
                style={{
                    borderLeft: '6px solid transparent',
                    borderRight: '6px solid transparent',
                    borderTop: '6px solid #e8d5b7',
                }}
            />
        </div>
    );
}

export default LoreTooltip;
